import React from "react";
import { IonCol, IonGrid, IonRow } from "@ionic/react";
import { Titulo, TextLink } from "app-principal-componentes-visuales";
import './ReintentarYsocialComponent.scss';

const ReintentarYsocialComponent = ({ onClick }) => {

    return (
        <IonCol onClick={onClick} className='reintentar-ysocial'>
            <IonRow>
                <Titulo
                    className="reintentar__title"
                    titulo={`Ocurrió un error. Presioná acá para reintentar`}
                />
            </IonRow>
            <IonRow className='link-container'>
                <TextLink
                    id="asistencia-medica-text-link-terminos-condiciones"
                    texto="Reintentar"
                    className="footer-terminos-condiciones"
                />
            </IonRow>
        </IonCol>
    )
}

export default ReintentarYsocialComponent